import { render, staticRenderFns } from "./SidebarCardLiteratureList.vue?vue&type=template&id=4f9f13e9"
import script from "./SidebarCardLiteratureList.vue?vue&type=script&lang=js"
export * from "./SidebarCardLiteratureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports